<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/7p1ApA/tc-custom/9780310396031.jpg?1705026874075" alt="This image is the cover for the book I Hope You Dance, Year of Weddings Novellas"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">I Hope You Dance, Year of Weddings Novellas
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Will a sworn bachelor determined to stay single fall in love with his dance teacher?</b></p><p>Grant Nichols is a genius in the kitchen and a klutz on the dance floor. But his friend’s wedding is shaping up to be a shindig the likes of which Kings Meadow has never seen—including dancing. Lots of dancing. Then he learns that a local dance teacher, Skye Foster, is offering dance lessons for the wedding party. The lessons are free, so what does he have to lose?</p><p>A former rodeo queen, Skye Foster teaches children ballet and tap during the day, but with the popularity of ballroom dancing and her own love of Country Swing, she’s been teaching adults in the evenings.</p><p>Grant comes from a family of ten siblings. He was the second oldest and believes he's had his fill of little rug rats. He’s happy with his bachelor state, despite the fact that he’s given up his ladies’ man lifestyle. Even he admits to his wilder nature and has been trying to clean up his act, with God's help.</p><p>Skye, on the other hand, loves being around kids. She would love to find the right guy and settle down to have half a dozen children of her own.</p><p>Grant and Skye are no match on paper. But when they step onto the dance floor, they move to a love song all their own.</p>Part of the second Year of Weddings novella collection by bestselling romance authors74-page romantic novellaIncludes discussion questions for book clubs
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Robin Lee Hatcher
      </h2>
      
      <p class="authorDescription body article"><P>Robin Lee Hatcher is the author of over 80 novels and novellas with over five million copies of her books in print. She is known for her heartwarming and emotionally charged stories of faith, courage, and love. Her numerous awards include the RITA Award, the Carol Award, the Christy Award, the HOLT Medallion, the National Reader&rsquo;s Choice Award, and the Faith, Hope &amp; Love Reader&rsquo;s Choice Award. Robin is also the recipient of prestigious Lifetime Achievement Awards from both American Christian Fiction Writers and Romance Writers of America. When not writing, she enjoys being with her family, spending time in the beautiful Idaho outdoors, Bible art journaling, reading books that make her cry, watching romantic movies, and decorative planning. Robin makes her home on the outskirts of Boise, sharing it with a demanding Papillon dog and a persnickety tuxedo cat.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Zondervan
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7db86288